import { render, staticRenderFns } from "./SubmissionsAndTalks.vue?vue&type=template&id=4018101c&"
import script from "./SubmissionsAndTalks.vue?vue&type=script&lang=js&"
export * from "./SubmissionsAndTalks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports